import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Section from 'components/common/Section';
import Phone from '../Phone';
import Footer from '../Footer';
import Email from 'owl/Email';

const PrivacyPolicy = () => {
  return (
    <>
      <Section className="py-3" style={{ minHeight: 'calc(100vh - 200px)' }}>
        <Row className="flex-center p-0">
          <Col sm={10} lg={7} className="col-xxl-5">
            <Card>
              <Card.Body className="overflow-hidden p-lg-6">
                <Row className="align-items-center justify-content-between">
                  <Col lg={12} className="ps-lg-4 my-5 text-lg-start">
                    <h3 className="text-primary text-center">
                      Automated Project Coordinator
                    </h3>
                    <h4 className="text-center">Privacy Policy</h4>
                    <h5 className="text-left">Data</h5>
                    <p>
                      We collect personal and activity data, which may be
                      linked.
                    </p>
                    <p>
                      We use technologies like cookies (small files stored on
                      your browser), web beacons, or unique device identifiers
                      to identify your computer or device so we can deliver a
                      better experience. Our systems also log information like
                      your browser, operating system and IP address.
                    </p>
                    <p>
                      We also may collect personally identifiable information
                      that you provide to us, such as your name, address, phone
                      number or email address.
                    </p>
                    {/* <p>
                      With your permission, we may also access other personal
                      information on your device, such as your phone book,
                      calendar or messages, in order to provide services to you.
                      If authorized by you, we may also access profile and other
                      information from services like Facebook.
                    </p> */}
                    <p>
                      Our systems may associate this personal information with
                      your activities in the course of providing service to you
                      (such as pages you view or things you click on or search
                      for).
                    </p>
                    <p>
                      We do not knowingly contact or collect personal
                      information from children under 13. If you believe we have
                      inadvertently collected such information, please contact
                      us so we can promptly obtain parental consent or remove
                      the information.
                    </p>
                    {/* <h5 className="text-left">Location</h5>
                    <p>
                      We may collect and share anonymous location data. To
                      customize our service for you, we and our partners may
                      collect, use, and share precise location data, including
                      the real-time geographic location of your computer or
                      device. This location data is collected anonymously in a
                      form that does not personally identify you and is used
                      only to provide and improve our service. We may obtain
                      your consent on your first use of the service.
                    </p> */}
                    <h5 className="text-left">Access</h5>
                    <p>
                      You can contact us by email to request to see or delete
                      your personal data.
                    </p>
                    <p>
                      If you do not request to delete your data, we may keep it
                      indefinitely.
                    </p>
                    {/* <h5 className="text-left">Sharing</h5>
                    <p>We may share personal data with companies we trust.</p>
                    <p>
                      We may share personally identifiable information (such as
                      name, address, email or phone) with trusted partners in
                      order to provide you with relevant advertising, offers or
                      services.
                    </p>
                    <p>
                      California residents are legally entitled (at no charge
                      and no more than once annually) to request information
                      about how we may have shared your information with others
                      for direct marketing purposes. Contact us for this
                      information: pcho@protonmail.com.
                    </p>
                    <p>
                      No mobile information will be shared with third
                      parties/affiliates for marketing/promotional purposes. All
                      the above categories exclude text messaging originator
                      opt-in data and consent; this information will not be
                      shared with any third parties.
                    </p> */}
                    {/* <h5 className="text-left">Ad Tracking</h5>
                    <p>
                      Ad companies collect anonymous data. You can opt out. Ad
                      companies may use and collect anonymous data about your
                      interests to customize content and advertising here and in
                      other sites and applications. Interest and location data
                      may be linked to your device, but is not linked to your
                      identity.
                    </p> */}
                    <h5 className="text-left">Contact</h5>
                    <p>
                      You can ask privacy questions. If you have any questions
                      or concerns about our privacy policies, please contact us
                      at <Email /> or <Phone />.
                    </p>
                    <h5 className="text-left">Vendors</h5>
                    <p>
                      Service providers access data on our behalf. In order to
                      serve you, we may share your personal and anonymous
                      information with other companies, including vendors and
                      contractors. Their use of information is limited to these
                      purposes, and subject to agreements that require them to
                      keep the information confidential. Our vendors provide
                      assurance that they take reasonable steps to safeguard the
                      data they hold on our behalf, although data security
                      cannot be guaranteed.
                    </p>
                    <p>
                      Analytics companies may access anonymous data (such as
                      your IP address or device ID) to help us understand how
                      our services are used. They use this data solely on our
                      behalf. They do not share it except in aggregate form; no
                      data is shared as to any individual user. Click to see
                      company privacy policies that govern their use of data.
                    </p>
                    <p>
                      No mobile information will be shared with third
                      parties/affiliates for marketing/promotional purposes. All
                      the above categories exclude text messaging originator
                      opt-in data and consent; this information will not be
                      shared with any third parties.
                    </p>
                    <h5 className="text-left">Special</h5>
                    <p>
                      Special situations may require disclosure of your data.
                    </p>
                    <p>
                      To operate the service, we also may make identifiable and
                      anonymous information available to third parties in these
                      limited circumstances: (1) with your express consent, (2)
                      when we have a good faith belief it is required by law,
                      (3) when we have a good faith belief it is necessary to
                      protect our rights or property, or (4) to any successor or
                      purchaser in a merger, acquisition, liquidation,
                      dissolution or sale of assets. Your consent will not be
                      required for disclosure in these cases, but we will
                      attempt to notify you, to the extent permitted by law to
                      do so.
                    </p>
                    <h5 className="text-left">More</h5>
                    <p>Our privacy policy may change from time to time.</p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Section>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
